const ErrorMessages = {
  // Email already synchronised
  emailAlreadySynchronised: 'This email is already syncronised',
};

export default ErrorMessages;
